<template>
  <div class="directory-container">
    <h3>Справочник ДО</h3>
    <button v-if="hasAccess(adminRoles)" class="add-kindergarten-btn" @click="openKindergartenDetailModal">Добавить ДО</button>

    <!-- Модальное окно -->
    <b-modal v-model="showKindergartenDetailModal" title="Создание ДО" hide-footer>
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="bin" class="form-label">БИН</label>
          <input type="text" v-model="newDocument.bin" class="form-control" id="bin" required />
        </div>
        <div class="mb-3">
          <label for="name" class="form-label">Название ДО</label>
          <input type="text" v-model="newDocument.name" class="form-control" id="name" required />
        </div>
        <div class="mb-3">
          <label for="kbe" class="form-label">КБЕ</label>
          <input type="text" v-model="newDocument.kbe" class="form-control" id="kbe" required />
        </div>
        <div class="mb-3">
          <label for="ownershipType" class="form-label">Тип собственности</label>
          <select v-model="newDocument.ownershipType" class="form-select" id="ownershipType" required>
            <option v-for="ownership in ownershipTypes" :key="ownership.code" :value="ownership">
              {{ ownership.name }}
            </option>
          </select>
        </div>
        <button type="submit" class="btn btn-primary">Создать</button>
      </form>
    </b-modal>

    <div class="row g-3">
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="doName" class="form-label col-md-3">Название ДО</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="doName" v-model="searchParams.doName" />
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">БИН</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.bin" />
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="kato" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <!--              <input type="text" @change="fetchDirectoryList(true)" class="form-control" id="kato" v-model="searchParams.kato" />-->
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="status" class="form-label col-md-3">Статус ДО</label>
          <div class="col-md-9">
            <div class="input-group">
              <select class="form-control" id="status" v-model="searchParams.status">
                <option value="">Все</option>
                <option value="ACTIVE">Активный</option>
                <option value="INACTIVE">Не активный</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchDirectoryList(true)">Поиск</button>
          <button class="btn btn-warning" @click="resetFilter">Сбросить фильтр</button>
        </div>
      </div>
    </div>
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <button :disabled="directoryList.length === 0 || isDownloading" class="btn btn-info" @click="downloadDirectoryReport">
        {{ isDownloading ? 'Загрузка...' : 'Выгрузить результат по фильтру' }}
      </button>
    </div>
    <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParams.pageSize"></b-pagination>
    <b-table-simple bordered="">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>#</b-th>
          <b-th>БИН ДО</b-th>
          <b-th>КБЕ</b-th>
          <b-th>Тип собственности</b-th>
          <b-th>LMS id</b-th>
          <b-th>Название ДО</b-th>
          <b-th>БИН банка</b-th>
          <b-th>БИК банка</b-th>
          <b-th>ИИК</b-th>
          <b-th>Группа региона</b-th>
          <b-th>Тип региона</b-th>
          <b-th>Тип населенного пункта</b-th>
          <b-th>Населенный пункт</b-th>
          <b-th>Физический адресс</b-th>
          <b-th>Номер договора и дата</b-th>
          <b-th>Проектная мощность</b-th>
          <b-th>Сумма надбавки</b-th>
          <b-th>Статус ДО</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(document, docIndex) in directoryList" :key="docIndex">
          <b-tr v-if="document.lmsSystems.length > 0" v-for="(lmsSystem, lmsIndex) in document.lmsSystems" :key="lmsIndex">
            <b-td v-if="lmsIndex === 0" :rowspan="document.lmsSystems.length">{{ pageSize*(currentPage-1)+docIndex+1 }}</b-td>
            <b-td v-if="lmsIndex === 0" :rowspan="document.lmsSystems.length">
              <router-link :to="`/directory/${document.id}`" class="username-link">
                {{ document.bin }}
              </router-link>
            </b-td>
            <b-td v-if="lmsIndex === 0" :rowspan="document.lmsSystems.length">{{ document.kbe }}</b-td>
            <b-td v-if="lmsIndex === 0" :rowspan="document.lmsSystems.length">{{ document.ownershipType?.code }}:{{ document.ownershipType?.name }}</b-td>

            <b-td>{{ lmsSystem.lmsId }}</b-td>
            <b-td>{{ lmsSystem.kindergartenName }}</b-td>
            <b-td>{{ lmsSystem.bankBin }}</b-td>
            <b-td>{{ lmsSystem.bankBic }}</b-td>
            <b-td>{{ lmsSystem.iik }}</b-td>
            <b-td>{{ lmsSystem.regionGroup?.code }}</b-td>
            <b-td>{{ lmsSystem.regionType?.code }}:{{ lmsSystem.regionType?.name }}</b-td>
            <b-td>{{ lmsSystem.localityType?.code }}:{{lmsSystem.localityType?.name}}</b-td>

            <b-th>{{ lmsSystem.kato?.nameRu }}</b-th>
            <b-th>{{ lmsSystem.address }}</b-th>
            <b-th>{{ lmsSystem.contractNumberAndDate }}</b-th>
            <b-th>{{ lmsSystem. childrenCapacity}}</b-th>
            <b-th>
              <p v-for="(allowance, allowanceIndex) in lmsSystem.kindergartenAllowances" :key="allowanceIndex">
                {{ allowance.educationalType?.code }}:{{ allowance.educationalType?.name }} <br>
                {{ allowance.durationTime?.code }}:{{ allowance.durationTime?.name }} <br>
                {{ allowance.allowanceAmount }} тг.
              </p>
            </b-th>
            <b-th>{{ getStatusLabel(lmsSystem.status)}}</b-th>
          </b-tr>
          <b-tr v-else>
            <b-td>{{ pageSize*(currentPage-1)+docIndex+1 }}</b-td>
            <b-td>
              <router-link :to="`/directory/${document.id}`" class="username-link">
                {{ document.bin }}
              </router-link>
            </b-td>
            <b-td>{{ document.kbe }}</b-td>
            <b-td>{{ document.ownershipType?.code }}:{{ document.ownershipType?.name }}</b-td>

            <b-td></b-td>
            <b-td></b-td>
            <b-td></b-td>
            <b-td></b-td>

            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { getKindergartenDocumentInfo, createKindergartenDocumentInfo } from "@/services/directoryService";
import { getGeneratedKindergartenDirectoryList } from "@/services/reportService";
import {Kato, KindergartenDocumentInfo, KindergartenSearchParams, OwnershipType} from "@/types/kindergarten";
import { PageResponse } from "@/types/pageResponse";
import authService from "@/services/authService";
import cacheService from "@/services/cacheService";
import Multiselect from "vue-multiselect";

export default defineComponent({
  name: "DirectoryView",
  components: {Multiselect},
  setup() {
    const pageResponse = ref<PageResponse<KindergartenDocumentInfo>>();
    const directoryList = ref<KindergartenDocumentInfo[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const pageSize = ref(10);
    const searchParams = reactive(new KindergartenSearchParams());
    const showKindergartenDetailModal = ref(false);
    const ownershipTypes = ref<OwnershipType[]>([]);
    const katoList = ref<Kato[]>([]);
    const adminRoles: string[] = authService.getAdminRoles();
    const kato = ref<Kato | null>(null);
    const hasAccess = authService.hasAccess;
    const isDownloading = ref(false);

    const newDocument = reactive<KindergartenDocumentInfo>({
      id: null,
      bin: "",
      name: "",
      bankBic: "",
      bankBin: "",
      kbe: "",
      iik: "",
      ownershipType: null,
      lmsSystems: [],
    });

    const getStatusLabel = (status: string) => {
      switch (status) {
        case "ACTIVE":
          return "Активный";
        case "INACTIVE":
          return "Не активный";
        default:
          return status || "Неизвестно";
      }
    };

    const openKindergartenDetailModal = () => {
      showKindergartenDetailModal.value = true; // Открытие модального окна
    };

    const closeKindergartenDetailModal = () => {
      showKindergartenDetailModal.value = false; // Закрытие модального окна
    };

    const submitForm = async () => {
      try {
        await createKindergartenDocumentInfo(newDocument); // Отправка данных на сервер
        closeKindergartenDetailModal(); // Закрытие модального окна
        await fetchDirectoryList(); // Обновление списка данных
      } catch (error) {
        console.error("Error creating kindergarten document:", error);
      }
    };

    const fetchDirectoryList = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParams.page = 0;
          currentPage.value = 1;
        }
        if (kato.value) {
          searchParams.katoCode = kato.value.code;
        }
        pageResponse.value = await getKindergartenDocumentInfo(searchParams);
        directoryList.value = pageResponse.value.content;
      } catch (error) {
        console.error("Error fetching directory list:", error);
      }
    };

    const resetFilter = async () => {
      searchParams.doName = "";
      searchParams.bin = "";
      searchParams.katoCode = null;
      kato.value = null;
      searchParams.status = "";
    }

    const fetchCachedDatas = async () => {
      ownershipTypes.value = await cacheService.useOwnershipType().fetchOwnershipType();
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    watch(currentPage, (newPage) => {
      searchParams.page = newPage - 1;
      fetchDirectoryList()
    });

    onMounted(() => {
      fetchDirectoryList();
      fetchCachedDatas();
    });

    const downloadDirectoryReport = async () => {
      try {
        isDownloading.value = true;
        await getGeneratedKindergartenDirectoryList({
          page: 0,
          pageSize: 0,
          doName: searchParams.doName,
          bin: searchParams.bin,
          katoCode: searchParams.katoCode,
          status: searchParams.status,
        });
      } catch (error) {
        console.error("Error downloading directory report:", error);
      } finally {
        isDownloading.value = false;
      }
    };

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    return {
      fetchDirectoryList,
      directoryList,
      pageResponse,
      currentPage,
      pageSize,
      searchParams,
      ownershipTypes,
      showKindergartenDetailModal,
      openKindergartenDetailModal,
      closeKindergartenDetailModal,
      newDocument,
      submitForm,
      adminRoles,
      hasAccess,
      katoList,
      formattedKatoLabel,
      kato,
      resetFilter,
      getStatusLabel,
      isDownloading,
      downloadDirectoryReport,
    };
  },
});
</script>

<style scoped>
.directory-container {
  padding: 20px;
  overflow:scroll;
}

h1 {
  margin-bottom: 20px;
}

.add-kindergarten-btn {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.add-kindergarten-btn:hover {
  background-color: #45a049;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}

.form-label {
  font-weight: bold;
}
</style>
